import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './atm-branch-locator.component.scss';
import { MapService } from '../../services/map.service';
import * as _ from 'lodash';
import axios from 'axios';
var AtmBranchLocator = /** @class */ (function (_super) {
    tslib_1.__extends(AtmBranchLocator, _super);
    function AtmBranchLocator(element) {
        var _this = _super.call(this, element) || this;
        new MapService().init();
        _this.event.register('googleMapsReady', null, _this.initMap.bind(_this));
        return _this;
    }
    AtmBranchLocator.prototype.init = function () {
        this.urlLatitudeLongitude = "https://digitalbanking.standardbank.co.za:8083/sbg-mobile/rest/Communications/geolocator/find";
        this.urlKeyword = "https://digitalbanking.standardbank.co.za:8083/sbg-mobile/rest/Communications/geolocator/search";
        this.urlKeywordFiltered = "https://digitalbanking.standardbank.co.za:8083/sbg-mobile/rest/Communications/geolocator/filteredSearch";
        this.urlGresIds = "https://digitalbanking.standardbank.co.za:8083/sbg-mobile/rest/Communications/geolocator";
        // this.urlLatitudeLongitude = "https://testdigitalbanking.standardbank.co.za:7083/sbg-mobile/rest/Communications/geolocator/find";
        // this.urlKeyword = "https://testdigitalbanking.standardbank.co.za:7083/sbg-mobile/rest/Communications/geolocator/search";
        // this.urlKeywordFiltered = "https://testdigitalbanking.standardbank.co.za:7083/sbg-mobile/rest/Communications/geolocator/filteredSearch";
        // this.urlGresIds = "https://testdigitalbanking.standardbank.co.za:7083/sbg-mobile/rest/Communications/geolocator";
        if (this.element.getAttribute('data-latitude')) {
            this.attributeLatitude = this.element.getAttribute('data-latitude');
        }
        if (this.element.getAttribute('data-longitude')) {
            this.attributeLongitude = this.element.getAttribute('data-longitude');
        }
        if (this.element.getAttribute('data-zoom')) {
            this.attributeZoom = this.element.getAttribute('data-zoom');
        }
        if (this.element.getAttribute('data-gres')) {
            this.attributeGresIds = this.element.getAttribute('data-gres');
        }
        if (this.element.getAttribute('data-language')) {
            this.attributeLanguage = this.element.getAttribute('data-language');
        }
        if (this.element.getAttribute('data-radius')) {
            this.attributeRadius = this.element.getAttribute('data-radius');
        }
        else {
            this.attributeRadius = 5;
        }
        if (this.element.getAttribute('data-closure-link')) {
            this.attributeClosureLink = this.element.getAttribute('data-closure-link');
        }
        else {
            this.attributeClosureLink = 'https://www.standardbank.co.za/southafrica/personal/covid-19/support/branch-locator';
        }
        if (this.element.getAttribute('data-country')) {
            this.attributeCountry = this.element.getAttribute('data-country');
        }
        this.fixedLatitude = -34.397;
        this.fixedLongitude = -34.397;
        this.valuesSearchKeyword = "";
        this.valuesSearchKeywordPrevious = "";
        this.valuesCheckboxSelected = ['All'];
        this.valuesLanguageProperties = [];
        this.currentLocation = {
            lat: this.fixedLatitude,
            lng: this.fixedLongitude
        };
        this.markers = [];
        this.hasLatitudeLongitude = false;
        this.mapContainer = this.element.querySelector('#map');
        this.containerBlocks = this.element.querySelector('.js-feed-container');
        this.containerDetail = this.element.querySelector('.js-feed-container-detail');
        this.containerPagination = this.element.querySelector('.atm-branch-locator__pagination');
        this.containerBackToResults = this.element.querySelector('.atm-branch-locator__back');
        this.containerCheckboxes = this.element.querySelector('.atm-branch-locator__checkboxes');
        this.containerMenu = this.element.querySelector('.atm-branch-locator__menu');
        this.containerNoResults = this.element.querySelector('.atm-branch-locator__noresults');
        this.containerPopup = this.element.querySelector('.atm-branch-locator__popup');
        this.containerPopupClose = this.element.querySelector('.atm-branch-locator__popup--inner__close');
        this.containerPopupServices = this.element.querySelector('.atm-branch-locator__popup--services');
        this.containerPopupServicesClose = this.element.querySelector('.atm-branch-locator__popup--services__inner--close');
        this.containerPopupGeneralInfo = this.element.querySelector('.atm-branch-locator__popup--generalinfo');
        this.containerPopupGeneralInfoIcon = this.element.querySelector('.atm-branch-locator__filtering--tooltip');
        this.containerPopupGeneralInfoClose = this.element.querySelector('.atm-branch-locator__popup--generalinfo__inner--close');
        this.containerInfoLink = this.element.querySelector('.atm-branch-locator__content--popup');
        this.containerLoader = this.element.querySelector('.atm-branch-locator__loader');
        this.containerNoGPS = this.element.querySelector('.atm-branch-locator__nogps');
        this.containerCenterChanged = this.element.querySelector('.atm-branch-locator__centerchanged');
        this.containerSearchBar = this.element.querySelector('.atm-branch-locator__map--search');
        this.containerFiltering = this.element.querySelector('.atm-branch-locator__filtering');
        this.buttonCurrentLocation = this.element.querySelector('.js-current-location');
        this.buttonSearch = Array.from(this.element.querySelectorAll('.filter-builder__form-field--searchbutton'));
        this.buttonCheckboxes = Array.from(this.element.querySelectorAll('input.js-main-checkboxes'));
        this.buttonPaginationNumbers = Array.from(this.element.querySelectorAll('.pagination__item'));
        this.buttonBackToResults = Array.from(this.element.querySelectorAll('.js-back-to-results'));
        this.buttonMobileSwipe = this.element.querySelector('.atm-branch-locator__mobile');
        this.buttonNewSearch = this.element.querySelector('.js-new-search');
        this.buttonCloseNoGPS = this.element.querySelector('.atm-branch-locator__nogps--close');
        this.buttonCenterChanged = this.element.querySelector('.atm-branch-locator__centerchanged--button');
        this.filterForm = this.element.querySelector('form');
        this.filterFormSubmitButton = this.element.querySelector('.js-submit-advanced-search-filter');
        this.form = Array.from(this.element.querySelectorAll('form'));
        this.formSearchInputs = Array.from(this.element.querySelectorAll('.js-search-bar'));
        var getLang = this.getCookie('sbgLang');
        if (getLang) {
            this.valuesLocale = getLang;
        }
        else {
            if (this.element.getAttribute('data-language')) {
                this.valuesLocale = this.attributeLanguage;
            }
            else {
                this.valuesLocale = "en";
            }
        }
        // datalayer
        dataLayer.search.filter = "All";
        this.detectHeader();
        ////////////////////////////////////// 
        // querystrings
        //////////////////////////////////////
        if (this.queryString('country')) {
            this.attributeCountry = this.queryString('country');
        }
        ////////////////////////////////////// 
        // filtering options
        //////////////////////////////////////
        this.initFilteringOptions(this.element);
    };
    AtmBranchLocator.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonCurrentLocation) {
            this.buttonCurrentLocation.addEventListener('click', function (event) {
                // this.getCurrentLocation();
            });
        }
        if (this.buttonSearch) {
            this.buttonSearch.map(function (button) { return button.addEventListener('click', function (event) {
                event.preventDefault();
                if (document.activeElement != document.body) {
                    document.activeElement.blur();
                }
                _this.closeDetail();
                _this.closeNoResults();
                _this.filteringOptionsClearSelectAll();
                _this.filteringOptionsShowHide(true);
                _this.createMarkersKeyword();
            }); });
        }
        if (this.buttonCheckboxes) {
            this.buttonCheckboxes.map(function (checkbox) { return checkbox.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var value = element.getAttribute('data-value');
                if (value === 'All') {
                    if (_this.valuesSearchKeyword) {
                        _this.filteringOptionsEnabled();
                    }
                    else {
                        _this.filteringOptionsDisabled();
                    }
                    dataLayer.search.filter = "All";
                    _this.buttonCheckboxes.map(function (checkboxRemove) {
                        checkboxRemove.checked = false;
                        checkboxRemove.removeAttribute('checked');
                    });
                    element.checked = true;
                    element.setAttribute('checked', 'checked');
                }
                if (value === 'ATM') {
                    _this.filteringOptionsDisabled();
                    dataLayer.search.filter = "ATMs";
                    _this.buttonCheckboxes.map(function (checkboxRemove) {
                        checkboxRemove.checked = false;
                        checkboxRemove.removeAttribute('checked');
                    });
                    element.checked = true;
                    element.setAttribute('checked', 'checked');
                }
                if (value === 'Branch') {
                    if (_this.valuesSearchKeyword) {
                        _this.filteringOptionsEnabled();
                    }
                    else {
                        _this.filteringOptionsDisabled();
                    }
                    dataLayer.search.filter = "Branch";
                    _this.buttonCheckboxes.map(function (checkboxRemove) {
                        checkboxRemove.checked = false;
                        checkboxRemove.removeAttribute('checked');
                    });
                    element.checked = true;
                    element.setAttribute('checked', 'checked');
                }
                _this.closeDetail();
                _this.closeNoResults();
                _this.filter();
            }); });
        }
        if (this.buttonPaginationNumbers) {
            this.buttonPaginationNumbers.map(function (button) { return button.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var paginationNumber = element.getAttribute('data-number');
                _this.createMap();
            }); });
        }
        if (this.buttonBackToResults) {
            this.buttonBackToResults.map(function (item) { return item.addEventListener('click', function (event) {
                _this.valuesSearchKeyword = _this.valuesSearchKeywordPrevious;
                _this.formSearchInputs.map(function (item) {
                    item.value = _this.valuesSearchKeyword;
                });
                _this.containerBackToResults.classList.add('d-none');
                _this.containerDetail.classList.add('d-none');
                _this.containerNoResults.classList.add('d-none');
                _this.containerCheckboxes.classList.remove('d-none');
                _this.containerBlocks.classList.remove('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.containerFiltering.classList.remove('d-none');
                for (var indMarker = 0; indMarker < _this.markers.length; indMarker++) {
                    _this.markers[indMarker].setVisible(true);
                    _this.markers[indMarker].setIcon(_this.markers[indMarker].iconOriginal);
                }
                var details = Array.from(_this.element.querySelectorAll('.atm-branch-locator__content--item'));
                details.map(function (detail) {
                    detail.classList.add('d-none');
                });
                _this.filteringOptionsShowHide(true);
            }); });
        }
        if (this.buttonMobileSwipe) {
            this.buttonMobileSwipe.addEventListener('touchstart', function (event) {
                if (_this.containerMenu.classList.contains('atm-branch-locator__menu--mobile__opened')) {
                    _this.containerMenu.classList.remove('atm-branch-locator__menu--mobile__opened');
                }
                else {
                    _this.containerMenu.classList.add('atm-branch-locator__menu--mobile__opened');
                }
            });
            this.buttonMobileSwipe.addEventListener('click', function (event) {
                if (_this.containerMenu.classList.contains('atm-branch-locator__menu--mobile__opened')) {
                    _this.containerMenu.classList.remove('atm-branch-locator__menu--mobile__opened');
                }
                else {
                    _this.containerMenu.classList.add('atm-branch-locator__menu--mobile__opened');
                }
            });
        }
        if (this.buttonNewSearch) {
            this.buttonNewSearch.addEventListener('touchstart', function (event) {
                _this.valuesSearchKeyword = _this.valuesSearchKeywordPrevious;
                _this.formSearchInputs.map(function (item) {
                    item.value = _this.valuesSearchKeyword;
                });
                _this.containerBackToResults.classList.add('d-none');
                _this.containerDetail.classList.add('d-none');
                _this.containerNoResults.classList.add('d-none');
                _this.containerCheckboxes.classList.remove('d-none');
                _this.containerBlocks.classList.remove('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.formSearchInputs.map(function (item) {
                    item.value = '';
                });
            });
            this.buttonNewSearch.addEventListener('click', function (event) {
                _this.valuesSearchKeyword = _this.valuesSearchKeywordPrevious;
                _this.formSearchInputs.map(function (item) {
                    item.value = _this.valuesSearchKeyword;
                });
                _this.containerBackToResults.classList.add('d-none');
                _this.containerDetail.classList.add('d-none');
                _this.containerNoResults.classList.add('d-none');
                _this.containerCheckboxes.classList.remove('d-none');
                _this.containerBlocks.classList.remove('d-none');
                _this.containerPagination.classList.add('d-none');
                _this.formSearchInputs.map(function (item) {
                    item.value = '';
                });
            });
        }
        if (this.form) {
            this.form.map(function (item) { return item.addEventListener('submit', function (evt) {
                event.preventDefault();
                if (document.activeElement != document.body) {
                    document.activeElement.blur();
                }
                _this.closeDetail();
                _this.closeNoResults();
                _this.filteringOptionsClearSelectAll();
                _this.filteringOptionsShowHide(true);
                _this.createMarkersKeyword();
            }); });
        }
        if (this.formSearchInputs) {
            this.formSearchInputs.map(function (item) { return item.addEventListener('keydown', function (evt) {
                var element = undefined;
                if (event.currentTarget) {
                    element = evt.currentTarget;
                }
                else {
                    element = evt.target;
                }
                _this.valuesSearchKeyword = element.value;
            }); });
            this.formSearchInputs.map(function (item) { return item.addEventListener('paste', function (evt) {
                var element = undefined;
                if (event.currentTarget) {
                    element = evt.currentTarget;
                }
                else {
                    element = evt.target;
                }
                _this.valuesSearchKeyword = element.value;
            }); });
            this.formSearchInputs.map(function (item) { return item.addEventListener('focus', function (evt) {
                _this.containerMenu.classList.add('atm-branch-locator__menu--closed');
            }); });
            this.formSearchInputs.map(function (item) { return item.addEventListener('blur', function (evt) {
                _this.containerMenu.classList.remove('atm-branch-locator__menu--closed');
            }); });
        }
        if (this.containerPopupClose) {
            this.containerPopupClose.addEventListener('touchstart', function (event) {
                _this.containerPopup.classList.remove('atm-branch-locator__popup__opened');
            });
            this.containerPopupClose.addEventListener('click', function (event) {
                _this.containerPopup.classList.remove('atm-branch-locator__popup__opened');
            });
        }
        if (this.containerPopupServicesClose) {
            this.containerPopupServicesClose.addEventListener('touchstart', function (event) {
                _this.containerPopupServices.classList.remove('atm-branch-locator__popup--services__opened');
            });
            this.containerPopupServicesClose.addEventListener('click', function (event) {
                _this.containerPopupServices.classList.remove('atm-branch-locator__popup--services__opened');
            });
        }
        if (this.containerPopupGeneralInfoIcon) {
            this.containerPopupGeneralInfoIcon.addEventListener('touchstart', function (event) {
                console.log(event);
                if (_this.containerPopupGeneralInfo.classList.contains('atm-branch-locator__popup--generalinfo__opened')) {
                    _this.containerPopupGeneralInfo.classList.remove('atm-branch-locator__popup--generalinfo__opened');
                }
                else {
                    _this.containerPopupGeneralInfo.classList.add('atm-branch-locator__popup--generalinfo__opened');
                }
            });
            this.containerPopupGeneralInfoIcon.addEventListener('click', function (event) {
                console.log(event);
                if (_this.containerPopupGeneralInfo.classList.contains('atm-branch-locator__popup--generalinfo__opened')) {
                    _this.containerPopupGeneralInfo.classList.remove('atm-branch-locator__popup--generalinfo__opened');
                }
                else {
                    _this.containerPopupGeneralInfo.classList.add('atm-branch-locator__popup--generalinfo__opened');
                }
            });
        }
        if (this.containerPopupGeneralInfoClose) {
            this.containerPopupGeneralInfoClose.addEventListener('touchstart', function (event) {
                _this.containerPopupGeneralInfo.classList.remove('atm-branch-locator__popup--generalinfo__opened');
            });
            this.containerPopupGeneralInfoClose.addEventListener('click', function (event) {
                _this.containerPopupGeneralInfo.classList.remove('atm-branch-locator__popup--generalinfo__opened');
            });
        }
        if (this.buttonCloseNoGPS) {
            this.buttonCloseNoGPS.addEventListener('click', function (event) {
                _this.containerNoGPS.classList.remove('active');
            });
        }
        if (this.buttonCenterChanged) {
            this.buttonCenterChanged.addEventListener('click', function (event) {
                _this.containerCenterChanged.classList.remove('visible');
                _this.createMarkersLatLong();
            });
        }
    };
    AtmBranchLocator.prototype.initMap = function () {
        var _this = this;
        this.currentLocation = {
            lat: parseFloat(this.attributeLatitude),
            lng: parseFloat(this.attributeLongitude)
        };
        if (this.attributeZoom) {
            this.map = new google.maps.Map(this.mapContainer, {
                center: this.currentLocation,
                zoom: parseInt(this.attributeZoom),
                gestureHandling: 'cooperative',
                disableDefaultUI: true,
            });
        }
        else {
            this.map = new google.maps.Map(this.mapContainer, {
                center: this.currentLocation,
                zoom: 14,
                gestureHandling: 'cooperative',
                disableDefaultUI: true,
            });
        }
        // HTML 5 Geolocation
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (location) {
                _this.currentLocation = {
                    lat: location.coords.latitude,
                    lng: location.coords.longitude
                };
                _this.hasLatitudeLongitude = true;
                _this.createMap(true);
            }, function (error) {
                _this.containerNoGPS.classList.add('active');
                _this.currentLocation = {
                    lat: parseFloat(_this.attributeLatitude),
                    lng: parseFloat(_this.attributeLongitude)
                };
                _this.createMap(false);
            });
        }
        else {
            this.containerNoGPS.classList.add('active');
            this.currentLocation = {
                lat: parseFloat(this.attributeLatitude),
                lng: parseFloat(this.attributeLongitude)
            };
            this.createMap(false);
        }
        // move from center
        var mapMoved = false;
        google.maps.event.addListener(this.map, 'dragend', function () {
            mapMoved = true;
            if (_this.containerCenterChanged) {
                if (_this.zoomLevel > 12) {
                    var center = _this.map.getCenter();
                    var latitude = center.lat();
                    var longitude = center.lng();
                    _this.containerCenterChanged.classList.add('visible');
                    _this.currentLocation = {
                        lat: latitude,
                        lng: longitude
                    };
                }
                else {
                    _this.containerCenterChanged.classList.remove('visible');
                }
            }
        });
        // detect zoom level
        google.maps.event.addListener(this.map, 'zoom_changed', function () {
            var zoom = _this.map.getZoom();
            _this.zoomLevel = zoom;
            if (_this.containerCenterChanged) {
                if (mapMoved) {
                    if (_this.zoomLevel > 12) {
                        var center = _this.map.getCenter();
                        var latitude = center.lat();
                        var longitude = center.lng();
                        _this.containerCenterChanged.classList.add('visible');
                        _this.currentLocation = {
                            lat: latitude,
                            lng: longitude
                        };
                    }
                    else {
                        _this.containerCenterChanged.classList.remove('visible');
                    }
                }
            }
        });
        // this.map.addListener('center_changed', () => {
        // 	let center: any = this.map.getCenter();
        // 	let latitude: any = center.lat();
        // 	let longitude: any = center.lng();
        // 	this.containerCenterChanged.classList.add('visible');
        // 	this.currentLocation = {
        // 		lat: latitude,
        // 		lng: longitude
        // 	};
        // })
    };
    AtmBranchLocator.prototype.createMap = function (location, filtered) {
        if (location === void 0) { location = false; }
        if (filtered === void 0) { filtered = false; }
        this.containerLoader.classList.remove('d-none');
        this.containerBlocks.classList.add('d-none');
        if (this.valuesSearchKeyword) {
            if (!filtered) {
                this.map.setCenter(this.currentLocation);
                this.map.setZoom(this.attributeZoom);
            }
            if (this.valuesCheckboxSelected.includes('ATM')) {
                this.createMarkersKeyword();
            }
            else {
                if (this.filteringOptionsItemsValues) {
                    this.createMarkersKeywordFiltered();
                }
                else {
                    this.createMarkersKeyword();
                }
            }
        }
        else {
            if (location) {
                if (!filtered) {
                    this.map.setCenter(this.currentLocation);
                    this.map.setZoom(this.attributeZoom);
                }
                this.createMarkersLatLong();
            }
            else {
                if (this.attributeZoom) {
                    if (!filtered) {
                        this.map.setCenter(this.currentLocation);
                        this.map.setZoom(this.attributeZoom);
                    }
                    this.createMarkersGres();
                }
                else {
                    if (!filtered) {
                        this.map.setCenter(this.currentLocation);
                        this.map.setZoom(this.attributeZoom);
                    }
                    this.createMarkersGres();
                }
            }
        }
    };
    // CREATE MARKERS
    AtmBranchLocator.prototype.createMarkersLatLong = function () {
        var _this = this;
        var url = this.urlLatitudeLongitude;
        url = url + '?latitude=' + this.currentLocation.lat + '&longitude=' + this.currentLocation.lng + '&radius=' + this.attributeRadius + '&language=' + this.valuesLocale;
        if (this.attributeCountry) {
            url = url + '&country=' + this.attributeCountry;
        }
        axios.get(url).then(function (response) {
            var getLocation = response.data.centers;
            _this.valuesLanguageProperties = response.data.languageProperties;
            if (getLocation.length > 0) {
                _this.clearMarkers();
                _this.clearEntries();
                _this.clearContent();
                var newArray = _this.createArray(getLocation);
                if (newArray.length > 0) {
                    for (var index = 0; index < newArray.length; index++) {
                        _this.addEntry(newArray[index], index);
                        _this.addMarker(newArray[index], index);
                        _this.addContent(newArray[index], index);
                    }
                    _this.updateContentLanguage();
                    _this.containerLoader.classList.add('d-none');
                    _this.containerBlocks.classList.remove('d-none');
                    _this.map.setCenter({ lat: parseFloat(newArray[0].location.latitude), lng: parseFloat(newArray[0].location.longitude) });
                    _this.map.setZoom(13);
                }
                else {
                    _this.updateContentLanguage();
                    _this.noResultsContainer();
                }
            }
            else {
                _this.noResultsContainer();
                _this.updateContentLanguage();
            }
        }).catch(function (response) {
            console.log(response);
        });
    };
    AtmBranchLocator.prototype.createMarkersKeyword = function () {
        var _this = this;
        var url = this.urlKeyword;
        url = url + '?searchTerm=' + this.valuesSearchKeyword + '&language=' + this.valuesLocale;
        if (this.attributeCountry) {
            url = url + '&country=' + this.attributeCountry;
        }
        axios.get(url).then(function (response) {
            var getLocation = response.data.centers;
            _this.valuesLanguageProperties = response.data.languageProperties;
            if (getLocation.length > 0) {
                _this.clearMarkers();
                _this.clearEntries();
                _this.clearContent();
                var newArray = _this.createArray(getLocation);
                if (newArray.length > 0) {
                    dataLayer.searchTerm = _this.valuesSearchKeyword;
                    dataLayer.numSearchResults = newArray.length;
                    for (var index = 0; index < newArray.length; index++) {
                        _this.addEntry(newArray[index], index);
                        _this.addMarker(newArray[index], index);
                        _this.addContent(newArray[index], index);
                    }
                    _this.valuesSearchKeywordPrevious = _this.valuesSearchKeyword;
                    _this.updateContentLanguage();
                    _this.containerLoader.classList.add('d-none');
                    _this.containerBlocks.classList.remove('d-none');
                    _this.map.setCenter({ lat: parseFloat(newArray[0].location.latitude), lng: parseFloat(newArray[0].location.longitude) });
                    _this.map.setZoom(13);
                }
                else {
                    _this.updateContentLanguage();
                    _this.noResultsContainer();
                }
            }
            else {
                _this.updateContentLanguage();
                _this.noResultsContainer();
            }
        }).catch(function (response) {
            console.log(response);
        });
    };
    AtmBranchLocator.prototype.createMarkersKeywordFiltered = function () {
        var _this = this;
        var url = this.urlKeywordFiltered;
        url = url + '?term=' + this.valuesSearchKeyword + '&language=' + this.valuesLocale + '&filters=' + this.filteringOptionsItemsValues;
        if (this.attributeCountry) {
            url = url + '&country=' + this.attributeCountry;
        }
        axios.get(url).then(function (response) {
            var getLocation = response.data.centers;
            _this.valuesLanguageProperties = response.data.languageProperties;
            if (getLocation.length > 0) {
                _this.clearMarkers();
                _this.clearEntries();
                _this.clearContent();
                var newArray = _this.createArrayFiltered(getLocation);
                if (newArray.length > 0) {
                    dataLayer.searchTerm = _this.valuesSearchKeyword;
                    dataLayer.numSearchResults = newArray.length;
                    for (var index = 0; index < newArray.length; index++) {
                        _this.addEntry(newArray[index], index);
                        _this.addMarker(newArray[index], index);
                        _this.addContent(newArray[index], index);
                    }
                    _this.valuesSearchKeywordPrevious = _this.valuesSearchKeyword;
                    _this.updateContentLanguage();
                    _this.containerLoader.classList.add('d-none');
                    _this.containerBlocks.classList.remove('d-none');
                    _this.map.setCenter({ lat: parseFloat(newArray[0].location.latitude), lng: parseFloat(newArray[0].location.longitude) });
                    _this.map.setZoom(13);
                }
                else {
                    _this.updateContentLanguage();
                    _this.noResultsContainer();
                }
            }
            else {
                _this.updateContentLanguage();
                _this.noResultsContainer();
            }
        }).catch(function (response) {
            console.log(response);
        });
    };
    AtmBranchLocator.prototype.createMarkersGres = function () {
        var _this = this;
        var url = this.urlGresIds;
        url = url + '?gresId=' + this.attributeGresIds + '&language=' + this.valuesLocale;
        if (this.attributeCountry) {
            url = url + '&country=' + this.attributeCountry;
        }
        axios.get(url).then(function (response) {
            var getLocation = response.data.centers;
            _this.valuesLanguageProperties = response.data.languageProperties;
            if (getLocation.length > 0) {
                _this.clearMarkers();
                _this.clearEntries();
                _this.clearContent();
                var newArray = _this.createArray(getLocation, false);
                if (newArray.length > 0) {
                    for (var index = 0; index < newArray.length; index++) {
                        _this.addEntry(newArray[index], index);
                        _this.addMarker(newArray[index], index);
                        _this.addContent(newArray[index], index);
                    }
                    _this.updateContentLanguage();
                    _this.containerLoader.classList.add('d-none');
                    _this.containerBlocks.classList.remove('d-none');
                }
                else {
                    _this.updateContentLanguage();
                    _this.noResultsContainer();
                }
            }
            else {
                _this.updateContentLanguage();
                _this.noResultsContainer();
            }
        }).catch(function (response) {
            console.log(response);
        });
    };
    // ADD MARKERS, BLOCKS AND DETAILS
    AtmBranchLocator.prototype.addMarker = function (item, index) {
        var _this = this;
        var latitude = parseFloat(item.location.latitude);
        var longitude = parseFloat(item.location.longitude);
        var iconBranch = "/file_source/assets/img/branch-locator/locator_icon_branch.png";
        var iconBranchSelected = "/file_source/assets/img/branch-locator/locator_icon_branch_selected.png";
        var iconAtm = "/file_source/assets/img/branch-locator/locator_icon_single_atm.png";
        var iconAtmSelected = "/file_source/assets/img/branch-locator/locator_icon_single_atm_selected.png";
        var iconAtms = "/file_source/assets/img/branch-locator/locator_icon_multiple_atms.png";
        var iconAtmsSelected = "/file_source/assets/img/branch-locator/locator_icon_multiple_atms_selected.png";
        var icon = iconBranch;
        if (item.locationType === 'ATM') {
            icon = iconAtm;
        }
        if (item.locationType === 'ATMs') {
            icon = iconAtms;
        }
        var marker = new google.maps.Marker({
            position: {
                lng: longitude,
                lat: latitude
            },
            icon: icon,
            map: this.map,
            animation: google.maps.Animation.DROP
        });
        marker['containerIndex'] = index;
        if (item.locationType === 'ATM') {
            marker['iconOriginal'] = iconAtm;
        }
        else if (item.locationType === 'ATMs') {
            marker['iconOriginal'] = iconAtms;
        }
        else {
            marker['iconOriginal'] = iconBranch;
        }
        marker.addListener('click', function (event) {
            for (var indMarker = 0; indMarker < _this.markers.length; indMarker++) {
                if (index === indMarker) {
                    _this.markers[indMarker].setVisible(true);
                    if (item.locationType === 'ATM') {
                        _this.markers[indMarker].setIcon(iconAtmSelected);
                    }
                    else if (item.locationType === 'ATMs') {
                        _this.markers[indMarker].setIcon(iconAtmsSelected);
                    }
                    else {
                        _this.markers[indMarker].setIcon(iconBranchSelected);
                    }
                }
                else {
                    _this.markers[indMarker].setVisible(false);
                }
            }
            // analytics
            var newButton = document.createElement('a');
            newButton.classList.add('marker-click-button');
            newButton.setAttribute('data-id', 'link_content');
            newButton.setAttribute('data-text', 'Map Icon | ' + item.displayName + ' link click');
            newButton.setAttribute('data-intent', 'Informational');
            newButton.setAttribute('data-scope', 'ATM Branch Locator');
            document.body.appendChild(newButton);
            newButton.click();
            document.body.removeChild(newButton);
            _this.containerBlocks.classList.add('d-none');
            _this.containerPagination.classList.add('d-none');
            _this.containerCheckboxes.classList.add('d-none');
            _this.containerDetail.classList.remove('d-none');
            _this.containerBackToResults.classList.remove('d-none');
            _this.containerNoResults.classList.add('d-none');
            _this.containerMenu.classList.add('atm-branch-locator__menu--mobile__opened');
            _this.map.setZoom(14);
            _this.map.panTo(marker.getPosition());
            var detailBlock = _this.containerDetail.querySelector("div.atm-branch-locator__content--item[data-index='" + marker.containerIndex + "']");
            detailBlock.classList.remove('d-none');
            _this.filteringOptionsShowHide(false);
        });
        this.markers.push(marker);
    };
    AtmBranchLocator.prototype.addEntry = function (item, index) {
        var _this = this;
        var contentDiv = document.createElement('div');
        contentDiv.classList.add('atm-branch-locator__item');
        contentDiv.classList.add('js-ab-action');
        contentDiv.setAttribute('data-longitude', item.location.longitude);
        contentDiv.setAttribute('data-latitude', item.location.latitude);
        contentDiv.setAttribute('data-marker-index', index);
        contentDiv.setAttribute('data-type', item.locationType);
        // analytics
        contentDiv.setAttribute('data-id', 'link_content');
        contentDiv.setAttribute('data-text', 'Location List | ' + item.displayName + ' link click');
        contentDiv.setAttribute('data-intent', 'Informational');
        contentDiv.setAttribute('data-scope', 'ATM Branch Locator');
        contentDiv.addEventListener('click', function (event) {
            // analytics
            if (typeof _satellite == 'object') {
                dataLayer.pageName = "ATM Branch Locator | " + item.displayName;
                _satellite.track('globalVirtualPageView');
            }
            for (var indMarker = 0; indMarker < _this.markers.length; indMarker++) {
                if (index === indMarker) {
                    _this.markers[indMarker].setVisible(true);
                    if (item.locationType === 'ATM') {
                        _this.markers[indMarker].setIcon('/file_source/assets/img/branch-locator/locator_icon_single_atm_selected.png');
                    }
                    else if (item.locationType === 'ATMs') {
                        _this.markers[indMarker].setIcon('/file_source/assets/img/branch-locator/locator_icon_multiple_atms_selected.png');
                    }
                    else {
                        _this.markers[indMarker].setIcon('/file_source/assets/img/branch-locator/locator_icon_branch_selected.png');
                    }
                }
                else {
                    _this.markers[indMarker].setVisible(false);
                }
            }
            _this.containerBlocks.classList.add('d-none');
            _this.containerPagination.classList.add('d-none');
            _this.containerCheckboxes.classList.add('d-none');
            _this.containerFiltering.classList.add('d-none');
            _this.containerDetail.classList.remove('d-none');
            _this.containerBackToResults.classList.remove('d-none');
            _this.containerNoResults.classList.add('d-none');
            _this.containerMenu.classList.add('atm-branch-locator__menu--mobile__opened');
            var latitude = parseFloat(item.location.latitude);
            var longitude = parseFloat(item.location.longitude);
            // this.map.setZoom(14);
            _this.map.setZoom(13);
            _this.map.panTo({
                lng: longitude,
                lat: latitude
            });
            var detailBlock = _this.containerDetail.querySelector("div.atm-branch-locator__content--item[data-index='" + index + "']");
            detailBlock.classList.remove('d-none');
            _this.filteringOptionsShowHide(false);
        });
        var iconDiv = document.createElement('div');
        iconDiv.classList.add('atm-branch-locator__item--icon');
        if (item.locationType === 'ATM') {
            iconDiv.style.backgroundImage = "url(/file_source/assets/img/branch-locator/locator_icon_single_atm.png)";
        }
        else if (item.locationType === 'ATMs') {
            iconDiv.style.backgroundImage = "url(/file_source/assets/img/branch-locator/locator_icon_multiple_atms.png)";
        }
        else {
            iconDiv.style.backgroundImage = "url(/file_source/assets/img/branch-locator/locator_icon_branch.png)";
        }
        contentDiv.appendChild(iconDiv);
        var detailsDiv = document.createElement('div');
        detailsDiv.classList.add('atm-branch-locator__item--content');
        var detailsDivTitle = document.createElement('div');
        detailsDivTitle.classList.add('atm-branch-locator__item--content__title');
        detailsDivTitle.innerHTML = item.displayName;
        // begin open state
        var detailsOpenState = document.createElement('div');
        detailsOpenState.classList.add('atm-branch-locator__item--content__state');
        var detailsOpenStateIcon = document.createElement('div');
        detailsOpenStateIcon.classList.add('atm-branch-locator__item--content__state--icon');
        detailsOpenStateIcon.innerHTML = "<img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPlJREFUeNqsVMENwjAMbCL+hQ06Qkcom8CHb9sJgAmgXz6swAZkhI7QDWgngHN0VaMoBAG1dLKS+s6O41QlAXvuVku4Asid7RYw6vLo/XgVIFdACXRCAgYgpWgGNMDZFVOewJ3LGkEmUKEInbhcj0LKE2jxYZt8MMRfeVQrpLlfWUVPQDIDB1Yw9WCKszzNKqQHdSCpkPf0vkl8KXzNgC7Ug5gxXppfaJ7tKwHHhJePPRl+FLG8BRdpJFMSqVR4g+YkFpFzm0i/hNdqZsn8a+QVb2R+4Ks3gycTbDSnrnEm0bUbcKT3TeIb4c8ysfO9ndle8T//k5cAAwBee31VLXSa1gAAAABJRU5ErkJggg==\" width=\"100%\" />";
        detailsOpenState.appendChild(detailsOpenStateIcon);
        var detailsOpenStateText = document.createElement('div');
        detailsOpenStateText.classList.add('atm-branch-locator__item--content__state--text');
        detailsOpenStateText.innerHTML = 'Branch may be temporarily closed due to lockdown. Please verify <a href="' + this.attributeClosureLink + '" target="_blank">here</a>';
        detailsOpenState.appendChild(detailsOpenStateText);
        // end open state
        var detailsDivAddress = document.createElement('div');
        detailsDivAddress.classList.add('atm-branch-locator__item--content__address');
        if (item.locationType === 'ATM') {
            detailsDivAddress.innerHTML = '';
        }
        else {
            if (item.location.shoppingCentre) {
                detailsDivAddress.innerHTML = item.location.shoppingCentre;
            }
            else {
                if (item.location.buildingName) {
                    detailsDivAddress.innerHTML = item.location.buildingName;
                }
                else {
                    detailsDivAddress.innerHTML = '';
                }
            }
        }
        var addressString = '';
        var detailsDivTags = document.createElement('div');
        detailsDivTags.classList.add('atm-branch-locator__item--content__tags');
        if (item.location.street) {
            addressString += item.location.street;
        }
        if (item.location.suburb) {
            addressString += ', ' + item.location.suburb;
        }
        else {
            if (item.location.town) {
                addressString += ', ' + item.location.town;
            }
        }
        if (item.location.postalCode !== "0") {
            addressString += ', ' + item.location.postalCode;
        }
        detailsDivTags.innerHTML = addressString;
        var detailsDivDistance = document.createElement('div');
        detailsDivDistance.classList.add('atm-branch-locator__item--content__distance');
        //detailsDivDistance.innerHTML = "1.6km - <span>Open</span> until 15:30";
        var detailsDivGetDirections = document.createElement('div');
        detailsDivGetDirections.classList.add('atm-branch-locator__item--content__getdirections');
        var detailsDivGetDirectionsLink = document.createElement('a');
        detailsDivGetDirectionsLink.classList.add('link');
        detailsDivGetDirectionsLink.innerHTML = "Get Directions";
        detailsDivGetDirectionsLink.setAttribute('href', 'https://www.google.com/maps/search/?api=1&query=' + item.location.latitude + ',' + item.location.longitude);
        detailsDivGetDirectionsLink.setAttribute('target', '_blank');
        detailsDivGetDirectionsLink.setAttribute('data-intent', 'search');
        detailsDivGetDirectionsLink.setAttribute('data-scope', 'AtmBranchLocator');
        detailsDivGetDirectionsLink.setAttribute('data-id', 'link_content');
        detailsDivGetDirectionsLink.setAttribute('data-text', 'Get directions link click');
        detailsDivGetDirections.appendChild(detailsDivGetDirectionsLink);
        var detailsDivIcon = document.createElement('div');
        detailsDivIcon.classList.add('atm-branch-locator__item--content__icon');
        detailsDivIcon.style.backgroundImage = "url(/file_source/assets/img/branch-locator/blue_arrow.png)";
        detailsDiv.appendChild(detailsDivTitle);
        if (item.locationType === 'ATM' || item.locationType === 'ATMs') {
        }
        else {
            if (item.branchState !== 'Open') {
                detailsDiv.appendChild(detailsOpenState);
            }
        }
        detailsDiv.appendChild(detailsDivAddress);
        detailsDiv.appendChild(detailsDivTags);
        detailsDiv.appendChild(detailsDivDistance);
        detailsDiv.appendChild(detailsDivGetDirections);
        detailsDiv.appendChild(detailsDivIcon);
        contentDiv.appendChild(detailsDiv);
        this.containerBlocks.appendChild(contentDiv);
    };
    AtmBranchLocator.prototype.addContent = function (item, index) {
        var _this = this;
        /////////////////// CONTAINER
        var container = document.createElement('div');
        container.classList.add('atm-branch-locator__content--item');
        container.classList.add('d-none');
        container.setAttribute('data-index', index);
        /////////////////// BEGIN ICON
        var icon = document.createElement('div');
        icon.classList.add('atm-branch-locator__content--item__icon');
        icon.innerHTML = "";
        container.appendChild(icon);
        /////////////////// END ICON
        /////////////////// BEGIN CLOSE
        var close = document.createElement('div');
        close.classList.add('atm-branch-locator__content--item__close');
        close.classList.add('js-back-to-results');
        close.innerHTML = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n\t\t<svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n\t\t\t<!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch -->\n\t\t\t<title>icon-close</title>\n\t\t\t<desc>Created with Sketch.</desc>\n\t\t\t<defs><linearGradient xy=\"100%\" id=\"gradient\"><stop stop-color=\"#fff\" offset=\"0%\"></stop><stop stop-color=\"#fff\" offset=\"100%\"></stop></linearGradient></defs>\n\t\t\t<g id=\"Standard-Bank---Icon-Setup\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-239.000000, -1047.000000)\">\n\t\t\t\t<g id=\"icon-close\" transform=\"translate(240.000000, 1047.000000)\" fill=\"#000000\" stroke=\"#000000\" stroke-width=\"0.25\">\n\t\t\t\t\t<path d=\"M19.89,20.361 C20.0192516,20.50942 20.0117716,20.7325081 19.8728687,20.8719371 C19.7339658,21.0113662 19.5109076,21.0196895 19.362,20.891 L10,11.528 L0.64,20.89 C0.493364607,21.0356781 0.256635393,21.0356781 0.11,20.89 C0.0395894888,20.8199889 -4.752856e-07,20.7247935 -4.752856e-07,20.6255 C-4.752856e-07,20.5262065 0.0395894888,20.4310111 0.11,20.361 L9.472,11.001 L0.11,1.638 C0.0153246163,1.54332462 -0.0216503308,1.40533224 0.0130032636,1.27600327 C0.0476568579,1.14667429 0.148674288,1.04565686 0.278003266,1.01100326 C0.407332243,0.976349669 0.545324619,1.01332462 0.64,1.108 L10,10.472 L19.362,1.111 C19.4564967,1.01650324 19.5942288,0.979598056 19.7233137,1.01418627 C19.8523987,1.04877448 19.9532255,1.14960131 19.9878137,1.27868627 C20.0224019,1.40777124 19.9854968,1.54550325 19.891,1.64 L10.529,11 L19.891,20.361 L19.89,20.361 Z\" id=\"Shape\"></path>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</svg>";
        close.addEventListener('click', function (event) {
            _this.containerBackToResults.classList.add('d-none');
            _this.containerDetail.classList.add('d-none');
            _this.containerNoResults.classList.add('d-none');
            _this.containerCheckboxes.classList.remove('d-none');
            _this.containerBlocks.classList.remove('d-none');
            _this.containerPagination.classList.add('d-none');
            _this.containerFiltering.classList.remove('d-none');
            _this.filteringOptionsShowHide(true);
            // this.containerBackToResults.classList.add('d-none');
            // this.containerDetail.classList.add('d-none');
            // this.containerNoResults.classList.add('d-none');
            // this.containerCheckboxes.classList.remove('d-none');
            // this.containerBlocks.classList.remove('d-none');
            // this.containerPagination.classList.add('d-none');
            // this.containerFiltering.classList.remove('d-none');
            for (var indMarker = 0; indMarker < _this.markers.length; indMarker++) {
                _this.markers[indMarker].setVisible(true);
                _this.markers[indMarker].setIcon('/file_source/assets/img/branch-locator/locator_icon_branch.png');
            }
            var details = Array.from(_this.element.querySelectorAll('.atm-branch-locator__content--item'));
            details.map(function (detail) {
                detail.classList.add('d-none');
            });
        });
        container.appendChild(close);
        /////////////////// END CLOSE
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN DETAILS ///////////////////
        /////////////////////////////////////////////////////////
        var details = document.createElement('div');
        details.classList.add('atm-branch-locator__content--item__details');
        var detailsTitle = document.createElement('div');
        detailsTitle.classList.add('title');
        detailsTitle.classList.add('title--module-sub-title');
        detailsTitle.classList.add('atm-branch-locator__content--item__details--title');
        detailsTitle.innerHTML = item.displayName;
        details.appendChild(detailsTitle);
        // begin open state
        var detailsOpenState = document.createElement('div');
        detailsOpenState.classList.add('atm-branch-locator__item--content__state');
        var detailsOpenStateIcon = document.createElement('div');
        detailsOpenStateIcon.classList.add('atm-branch-locator__item--content__state--icon');
        detailsOpenStateIcon.innerHTML = "<img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPlJREFUeNqsVMENwjAMbCL+hQ06Qkcom8CHb9sJgAmgXz6swAZkhI7QDWgngHN0VaMoBAG1dLKS+s6O41QlAXvuVku4Asid7RYw6vLo/XgVIFdACXRCAgYgpWgGNMDZFVOewJ3LGkEmUKEInbhcj0LKE2jxYZt8MMRfeVQrpLlfWUVPQDIDB1Yw9WCKszzNKqQHdSCpkPf0vkl8KXzNgC7Ug5gxXppfaJ7tKwHHhJePPRl+FLG8BRdpJFMSqVR4g+YkFpFzm0i/hNdqZsn8a+QVb2R+4Ks3gycTbDSnrnEm0bUbcKT3TeIb4c8ysfO9ndle8T//k5cAAwBee31VLXSa1gAAAABJRU5ErkJggg==\" width=\"100%\" />";
        detailsOpenState.appendChild(detailsOpenStateIcon);
        var detailsOpenStateText = document.createElement('div');
        detailsOpenStateText.classList.add('atm-branch-locator__item--content__state--text');
        detailsOpenStateText.innerHTML = 'Branch may be temporarily closed due to lockdown. Please verify <a href="' + this.attributeClosureLink + '" target="_blank">here</a>';
        detailsOpenState.appendChild(detailsOpenStateText);
        if (item.locationType === 'ATM' || item.locationType === 'ATMs') {
        }
        else {
            if (item.branchState !== 'Open') {
                details.appendChild(detailsOpenState);
            }
        }
        // end open state
        if (item.locationType === 'ATM') {
            if (item.centerType === 'Remote') {
                var detailsTags = document.createElement('div');
                detailsTags.classList.add('atm-branch-locator__content--item__details--tags');
                detailsTags.classList.add('js-descriptor-standalone-atm');
                detailsTags.innerHTML = "Standalone ATM";
                details.appendChild(detailsTags);
            }
            else {
                var detailsTags = document.createElement('div');
                detailsTags.classList.add('atm-branch-locator__content--item__details--tags');
                detailsTags.classList.add('js-descriptor-multiple-atms');
                detailsTags.innerHTML = "Multiple ATMs";
                details.appendChild(detailsTags);
            }
            // let countATMs: any = 0;
            // countATMs += parseInt(item.autobankTotal);
            // countATMs += parseInt(item.autocashTotal);
            // countATMs += parseInt(item.autoplusTotal);
            // if(countATMs > 1) {
            // 	let detailsTags = document.createElement('div');
            // 	detailsTags.classList.add('atm-branch-locator__content--item__details--tags');
            // 	detailsTags.classList.add('js-descriptor-multiple-atms');
            // 	detailsTags.innerHTML = "Multiple ATMs";
            // 	details.appendChild(detailsTags);
            // }else{
            // 	let detailsTags = document.createElement('div');
            // 	detailsTags.classList.add('atm-branch-locator__content--item__details--tags');
            // 	detailsTags.classList.add('js-descriptor-standalone-atm');
            // 	detailsTags.innerHTML = "Standalone ATM";
            // 	details.appendChild(detailsTags);
            // }
        }
        else if (item.locationType === 'ATMs') {
            var detailsTags = document.createElement('div');
            detailsTags.classList.add('atm-branch-locator__content--item__details--tags');
            detailsTags.classList.add('js-descriptor-multiple-atms');
            detailsTags.innerHTML = "Multiple ATMs";
            details.appendChild(detailsTags);
        }
        else {
            // let detailsTags = document.createElement('div');
            // detailsTags.classList.add('atm-branch-locator__content--item__details--tags');
            // detailsTags.innerHTML = "Branch";
            // details.appendChild(detailsTags);
        }
        container.appendChild(details);
        /////////////////////////////////////////////////////////
        /////////////////// END DETAILS ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN OPERATING TIMES ///////////////////
        /////////////////////////////////////////////////////////
        if (item.locationType === 'ATM') {
        }
        else if (item.locationType === 'ATMs') {
        }
        else {
            var hasOperatingHours_1 = true;
            var detailsOperatingHours = document.createElement('div');
            detailsOperatingHours.classList.add('atm-branch-locator__content--item__operating');
            var detailsOperatingHoursTitle = document.createElement('div');
            detailsOperatingHoursTitle.classList.add('atm-branch-locator__content--item__operating--title__normal');
            detailsOperatingHoursTitle.innerHTML = 'Operating Hours';
            // let detailsOperatingHoursIcon = document.createElement('div');
            // detailsOperatingHoursIcon.classList.add('atm-branch-locator__content--item__operating--icon');
            // detailsOperatingHoursIcon.classList.add('active');
            // detailsOperatingHoursIcon.innerHTML = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
            // <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
            // 	<path fill="#0089FF" d="M1.019 7.5L4.769 3.75 1.019 0 0 0.269 3.481 3.75 0 7.231z" transform="rotate(90 3.5 4.25)"/>
            // </svg>`;
            var detailsOperatingHoursContent_1 = document.createElement('div');
            detailsOperatingHoursContent_1.classList.add('atm-branch-locator__content--item__operating--content');
            detailsOperatingHoursContent_1.classList.add('atm-branch-locator__content--item__operating--content__opened');
            var operatingHours = item.operatingHours;
            operatingHours.map(function (operatingHoursItem) {
                var name = operatingHoursItem.group;
                var operatingHoursTime = document.createElement('div');
                operatingHoursTime.classList.add('atm-branch-locator__content--item__operating--content__time');
                operatingHoursTime.innerHTML = operatingHoursItem.hours;
                detailsOperatingHoursContent_1.appendChild(operatingHoursTime);
                if (operatingHoursItem.hours === 'UNKNOWN' || operatingHoursItem.hours === 'unknown') {
                    hasOperatingHours_1 = false;
                }
            });
            // detailsOperatingHours.addEventListener('click', (event)=>{
            // 	if (detailsOperatingHoursContent.classList.contains('atm-branch-locator__content--item__operating--content__opened')) {
            // 		detailsOperatingHoursContent.classList.remove('atm-branch-locator__content--item__operating--content__opened');
            // 		detailsOperatingHoursIcon.classList.remove('active');
            // 	} else {
            // 		detailsOperatingHoursContent.classList.add('atm-branch-locator__content--item__operating--content__opened');
            // 		detailsOperatingHoursIcon.classList.add('active');
            // 	}
            // })
            if (item.operatingHours) {
                if (item.operatingHours.length > 0) {
                    if (hasOperatingHours_1) {
                        detailsOperatingHours.appendChild(detailsOperatingHoursTitle);
                        // detailsOperatingHours.appendChild(detailsOperatingHoursIcon);
                        container.appendChild(detailsOperatingHours);
                        container.appendChild(detailsOperatingHoursContent_1);
                    }
                }
            }
        }
        /////////////////////////////////////////////////////////
        /////////////////// END OPERATING TIMES ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN TELLER TIMES ///////////////////
        /////////////////////////////////////////////////////////
        if (item.locationType === 'ATM') {
        }
        else if (item.locationType === 'ATMs') {
        }
        else {
            if (item.tellerServices !== undefined && item.tellerServices === 'Limited') {
                // if(item.tellerServices !== undefined && (item.tellerServices === 'Yes' || item.tellerServices === 'Limited')) {
                var detailsTellerOperatingHours = document.createElement('div');
                detailsTellerOperatingHours.classList.add('atm-branch-locator__content--item__teller');
                var detailsTellerOperatingHoursTitle = document.createElement('div');
                detailsTellerOperatingHoursTitle.classList.add('atm-branch-locator__content--item__teller--title__normal');
                detailsTellerOperatingHoursTitle.innerHTML = 'Teller Operating Hours';
                var detailsTellerOperatingHoursContent = document.createElement('div');
                detailsTellerOperatingHoursContent.classList.add('atm-branch-locator__content--item__teller--content');
                detailsTellerOperatingHoursContent.classList.add('atm-branch-locator__content--item__teller--content__opened');
                if (item.tellerServicesWeekdayOperatingHours !== undefined && item.tellerServicesWeekdayOperatingHours !== '') {
                    var tellerOperatingHoursTime = document.createElement('div');
                    tellerOperatingHoursTime.classList.add('atm-branch-locator__content--item__teller--content__time');
                    tellerOperatingHoursTime.innerHTML = item.tellerServicesWeekdayOperatingHours;
                    detailsTellerOperatingHoursContent.appendChild(tellerOperatingHoursTime);
                }
                if (item.tellerServicesWeekendOperatingHours !== undefined && item.tellerServicesWeekendOperatingHours !== '') {
                    var tellerServicesWeekendOperatingHoursNew = item.tellerServicesWeekendOperatingHours;
                    tellerServicesWeekendOperatingHoursNew = tellerServicesWeekendOperatingHoursNew.replace(/;/g, '<br>');
                    var tellerOperatingHoursTime = document.createElement('div');
                    tellerOperatingHoursTime.classList.add('atm-branch-locator__content--item__teller--content__time');
                    tellerOperatingHoursTime.innerHTML = tellerServicesWeekendOperatingHoursNew;
                    detailsTellerOperatingHoursContent.appendChild(tellerOperatingHoursTime);
                }
                detailsTellerOperatingHours.appendChild(detailsTellerOperatingHoursTitle);
                detailsTellerOperatingHours.appendChild(detailsTellerOperatingHoursContent);
                container.appendChild(detailsTellerOperatingHours);
            }
        }
        /////////////////////////////////////////////////////////
        /////////////////// END TELLER TIMES ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN ADDRESS ///////////////////
        /////////////////////////////////////////////////////////
        var address = document.createElement('div');
        address.classList.add('atm-branch-locator__content--item__address');
        var addressTitle = document.createElement('div');
        addressTitle.classList.add('atm-branch-locator__content--item__address--title__normal');
        addressTitle.innerHTML = "Address";
        // if(item.location.shoppingCentre){
        // 	addressTitle.innerHTML = item.location.shoppingCentre;
        // }else{
        // 	if(item.location.buildingName){
        // 		addressTitle.innerHTML = item.location.buildingName;
        // 	}else{
        // 		addressTitle.innerHTML = "Location";
        // 	}
        // }
        // let addressIcon = document.createElement('div');
        // addressIcon.classList.add('atm-branch-locator__content--item__address--icon');
        // addressIcon.classList.add('active');
        // addressIcon.innerHTML = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
        // <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
        // 	<path fill="#0089FF" d="M1.019 7.5L4.769 3.75 1.019 0 0 0.269 3.481 3.75 0 7.231z" transform="rotate(90 3.5 4.25)"/>
        // </svg>`;
        var addressString = '';
        var addressContent = document.createElement('div');
        addressContent.classList.add('atm-branch-locator__content--item__address--content');
        addressContent.classList.add('atm-branch-locator__content--item__address--content__opened');
        if (item.location.shoppingCentre !== undefined && item.location.shoppingCentre !== null && item.location.shoppingCentre !== 'null' && item.location.shoppingCentre !== '') {
            addressString += item.location.shoppingCentre + "<br>";
        }
        else {
            if (item.location.buildingName !== undefined && item.location.buildingName !== null && item.location.buildingName !== 'null' && item.location.buildingName !== '') {
                addressString += item.location.buildingName + "<br>";
            }
        }
        if (item.location.shopNo !== undefined && item.location.shopNo !== null && item.location.shopNo !== 'null' && item.location.shopNo !== '') {
            addressString += item.location.shopNo + "<br>";
        }
        if (item.location.street !== undefined && item.location.street !== null && item.location.street !== 'null' && item.location.street !== '') {
            addressString += item.location.street + "<br>";
        }
        var needsBr = false;
        if (item.location.suburb !== undefined && item.location.suburb !== null && item.location.suburb !== 'null' && item.location.suburb !== '') {
            addressString += item.location.suburb;
            if (item.location.town !== undefined && item.location.town !== null && item.location.town !== 'null' && item.location.town !== '') {
                addressString += ", " + item.location.town;
                needsBr = true;
            }
            if (item.location.postalCode !== "0" && item.location.postalCode !== undefined && item.location.postalCode !== null && item.location.postalCode !== 'null' && item.location.postalCode !== '') {
                addressString += ", " + item.location.postalCode;
                needsBr = true;
            }
        }
        else {
            if (item.location.town !== undefined && item.location.town !== null && item.location.town !== 'null' && item.location.town !== '') {
                addressString += item.location.town;
                needsBr = true;
            }
            if (item.location.postalCode !== "0" && item.location.postalCode !== undefined && item.location.postalCode !== null && item.location.postalCode !== 'null' && item.location.postalCode !== '') {
                addressString += ", " + item.location.postalCode;
                needsBr = true;
            }
        }
        if (needsBr) {
            addressString += "<br>";
        }
        if (item.location.nationalProv !== undefined && item.location.nationalProv !== null && item.location.nationalProv !== 'null' && item.location.nationalProv !== '') {
            addressString += item.location.nationalProv + "<br>";
        }
        // if(item.location.country) {
        // 	addressString += item.location.country + "<br>";
        // }
        addressContent.innerHTML = addressString;
        // address.addEventListener('click', (event)=>{
        // 	if (addressContent.classList.contains('atm-branch-locator__content--item__address--content__opened')) {
        // 		addressContent.classList.remove('atm-branch-locator__content--item__address--content__opened');
        // 		addressIcon.classList.remove('active');
        // 	} else {
        // 		addressContent.classList.add('atm-branch-locator__content--item__address--content__opened');
        // 		addressIcon.classList.add('active');
        // 	}
        // })
        address.appendChild(addressTitle);
        // address.appendChild(addressIcon);
        container.appendChild(address);
        container.appendChild(addressContent);
        var addressLatLong = document.createElement('div');
        addressLatLong.classList.add('atm-branch-locator__content--item__address--latlng');
        if (this.isIOSDevice()) {
            var addressLatLongButton = document.createElement('a');
            addressLatLongButton.setAttribute('href', 'https://www.google.com/maps/search/?api=1&query=' + item.location.latitude + ',' + item.location.longitude);
            addressLatLongButton.setAttribute('target', '_blank');
            addressLatLongButton.classList.add('link');
            var addressLatLongIcon = document.createElement('span');
            addressLatLongIcon.style.backgroundImage = "url(/file_source/assets/img/branch-locator/icon_location.png)";
            addressLatLongButton.appendChild(addressLatLongIcon);
            var addressLatLongTitle = document.createElement('span');
            addressLatLongTitle.classList.add('content');
            // addressLatLongTitle.innerHTML = item.location.latitude + ', ' + item.location.longitude;
            addressLatLongTitle.innerHTML = "Get Directions";
            addressLatLongButton.appendChild(addressLatLongTitle);
            addressLatLong.appendChild(addressLatLongButton);
            container.appendChild(addressLatLong);
        }
        else if (this.isANDROIDDevice()) {
            var addressLatLongButton = document.createElement('a');
            addressLatLongButton.setAttribute('href', 'https://www.google.com/maps/search/?api=1&query=' + item.location.latitude + ',' + item.location.longitude);
            addressLatLongButton.setAttribute('target', '_blank');
            addressLatLongButton.setAttribute('data-id', 'link_content');
            addressLatLongButton.setAttribute('data-text', 'Location Detail | ' + item.displayName + ' | Get Directions button click');
            addressLatLongButton.setAttribute('data-intent', 'Informational');
            addressLatLongButton.setAttribute('data-scope', 'AtmBranchLocator');
            addressLatLongButton.classList.add('link');
            var addressLatLongIcon = document.createElement('span');
            addressLatLongIcon.style.backgroundImage = "url(/file_source/assets/img/branch-locator/icon_location.png)";
            addressLatLongButton.appendChild(addressLatLongIcon);
            var addressLatLongTitle = document.createElement('span');
            addressLatLongTitle.classList.add('content');
            // addressLatLongTitle.innerHTML = item.location.latitude + ', ' + item.location.longitude;
            addressLatLongTitle.innerHTML = "Get Directions";
            addressLatLongButton.appendChild(addressLatLongTitle);
            addressLatLong.appendChild(addressLatLongButton);
            container.appendChild(addressLatLong);
        }
        else {
            var addressLatLongButton = document.createElement('a');
            addressLatLongButton.setAttribute('href', 'https://www.google.com/maps/search/?api=1&query=' + item.location.latitude + ',' + item.location.longitude);
            addressLatLongButton.setAttribute('target', '_blank');
            addressLatLongButton.setAttribute('data-id', 'link_content');
            addressLatLongButton.setAttribute('data-text', 'Location Detail | ' + item.displayName + ' | Get Directions button click');
            addressLatLongButton.setAttribute('data-intent', 'Informational');
            addressLatLongButton.setAttribute('data-scope', 'AtmBranchLocator');
            addressLatLongButton.classList.add('link');
            var addressLatLongIcon = document.createElement('span');
            addressLatLongIcon.style.backgroundImage = "url(/file_source/assets/img/branch-locator/icon_location.png)";
            addressLatLongButton.appendChild(addressLatLongIcon);
            var addressLatLongTitle = document.createElement('span');
            addressLatLongTitle.classList.add('content');
            // addressLatLongTitle.innerHTML = item.location.latitude + ', ' + item.location.longitude;
            addressLatLongTitle.innerHTML = "Get Directions";
            addressLatLongButton.appendChild(addressLatLongTitle);
            addressLatLong.appendChild(addressLatLongButton);
            container.appendChild(addressLatLong);
        }
        /////////////////////////////////////////////////////////
        /////////////////// END ADDRESS ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN AVAILABLE ATMS ///////////////////
        /////////////////////////////////////////////////////////
        var availableATMS = document.createElement('div');
        availableATMS.classList.add('atm-branch-locator__content--item__availableatms');
        var availableATMSTitle = document.createElement('div');
        availableATMSTitle.classList.add('atm-branch-locator__content--item__availableatms--title');
        availableATMSTitle.innerHTML = 'Available types of ATMs';
        availableATMS.appendChild(availableATMSTitle);
        var availableATMSIcon = document.createElement('a');
        availableATMSIcon.classList.add('atm-branch-locator__content--item__availableatms--icon');
        availableATMSIcon.setAttribute('data-intent', 'search');
        availableATMSIcon.setAttribute('data-scope', 'AtmBranchLocator');
        availableATMSIcon.setAttribute('data-id', 'link_content');
        availableATMSIcon.setAttribute('data-text', 'Available types of atms link click');
        availableATMSIcon.innerHTML = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n    \t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm1 3H7v2h2V3zm0 4.004H7V13h2V7.004z\"/>\n\t\t</svg>";
        availableATMS.addEventListener('click', function (event) {
            var popup = _this.element.querySelector('.atm-branch-locator__popup');
            if (popup.classList.contains('atm-branch-locator__popup__opened')) {
                popup.classList.remove('atm-branch-locator__popup__opened');
            }
            else {
                popup.classList.add('atm-branch-locator__popup__opened');
            }
        });
        availableATMS.appendChild(availableATMSTitle);
        availableATMS.appendChild(availableATMSIcon);
        var availableATMSContent = document.createElement('div');
        availableATMSContent.classList.add('atm-branch-locator__content--item__availableatms--content');
        var atmAutobank = item.autobankTotal;
        var atmAutocash = item.autocashTotal;
        var atmAutoplus = item.autoplusTotal;
        var atmSpark = item.sparkTotal;
        if (atmAutobank > 0) {
            var atmAutobankContainer = document.createElement('div');
            atmAutobankContainer.classList.add('atm-branch-locator__content--item__availableatms--type');
            atmAutobankContainer.classList.add('js-descriptor-atm-autobank');
            atmAutobankContainer.innerHTML = atmAutobank + ' Autobank';
            availableATMSContent.appendChild(atmAutobankContainer);
        }
        if (atmAutocash > 0) {
            var atmAutocashContainer = document.createElement('div');
            atmAutocashContainer.classList.add('atm-branch-locator__content--item__availableatms--type');
            atmAutocashContainer.classList.add('js-descriptor-atm-autocash');
            atmAutocashContainer.innerHTML = atmAutocash + ' Autocash';
            availableATMSContent.appendChild(atmAutocashContainer);
        }
        if (atmAutoplus > 0) {
            var atmAutoplusContainer = document.createElement('div');
            atmAutoplusContainer.classList.add('atm-branch-locator__content--item__availableatms--type');
            atmAutoplusContainer.classList.add('js-descriptor-atm-autoplus');
            atmAutoplusContainer.innerHTML = atmAutoplus + ' Autoplus';
            availableATMSContent.appendChild(atmAutoplusContainer);
        }
        if (atmSpark > 0) {
            var atmSparkContent = document.createElement('div');
            atmSparkContent.classList.add('atm-branch-locator__content--item__availableatms--type');
            atmSparkContent.classList.add('js-descriptor-atm-spark');
            atmSparkContent.innerHTML = atmSpark + ' Spark';
            availableATMSContent.appendChild(atmSparkContent);
        }
        if (atmAutobank > 0 || atmAutocash > 0 || atmAutoplus > 0 || atmSpark > 0) {
            availableATMS.appendChild(availableATMSTitle);
            availableATMS.appendChild(availableATMSIcon);
            container.appendChild(availableATMS);
            container.appendChild(availableATMSContent);
        }
        /////////////////////////////////////////////////////////
        /////////////////// END AVAILABLE ATMS ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN ALSO OFFERS ///////////////////
        /////////////////////////////////////////////////////////
        if (item.locationType === 'ATM') {
        }
        else if (item.locationType === 'ATMs') {
        }
        else {
            var servicesArray = item.services;
            if (item.wheelChairAccess !== '') {
                if (item.wheelChairAccess === "YES" || item.wheelChairAccess === "1") {
                    servicesArray.push({ description: 'YES', name: 'Wheelchair access' });
                }
            }
            // if (item.shoppingCenterGeneratorStatus !== '') {
            //     if (item.shoppingCenterGeneratorStatus === "YES" || item.shoppingCenterGeneratorStatus === "1") {
            //         servicesArray.push({description: 'YES', name: 'Generator Power Backup'});
            //     }
            // }
            // clean up values
            var cashlessOutlet = false;
            var newServicesArray = [];
            for (var index_1 = 0; index_1 < servicesArray.length; index_1++) {
                var name_1 = servicesArray[index_1].name;
                if (name_1 === 'Cashless Outlet') {
                    cashlessOutlet = true;
                }
                if (name_1 === 'Safe Custody' || name_1 === 'Liberty Presence' || name_1 === 'Internet Kiosk' || name_1 === 'Cashless Outlet') {
                }
                else {
                    if (name_1 === 'SBFC presence') {
                        name_1 = 'Financial Planning Services';
                    }
                    if (name_1 === 'MIE presence') {
                        name_1 = 'Fingerprint Zone by MIE';
                    }
                    if (name_1 === 'Home Affairs Presence') {
                        name_1 = 'ID and Passport (new and renewal)';
                    }
                    if (name_1 === 'DHA Services') {
                        name_1 = 'ID - green book replacement';
                    }
                    var object = {
                        name: name_1,
                        description: 'YES'
                    };
                    newServicesArray.push(object);
                }
            }
            if (!cashlessOutlet) {
                var object = {
                    name: 'Cash processing',
                    description: 'YES'
                };
                newServicesArray.push(object);
            }
            newServicesArray = _.sortBy(newServicesArray, ['name']);
            // create string
            var servicesString = '';
            for (var index_2 = 0; index_2 < newServicesArray.length; index_2++) {
                var convertServiceString = newServicesArray[index_2].name;
                convertServiceString = convertServiceString.trim();
                if (index_2 === 0) {
                    servicesString += convertServiceString + "<br>";
                }
                else {
                    // servicesString += ', ' + convertServiceString;
                    servicesString += convertServiceString + "<br>";
                }
            }
            var servicesContainer = document.createElement('div');
            servicesContainer.classList.add('atm-branch-locator__content--item__alsooffers--container');
            var servicesInformation = document.createElement('div');
            servicesInformation.classList.add('atm-branch-locator__content--item__alsooffers--information');
            var servicesHeadingContainer = document.createElement('div');
            servicesHeadingContainer.classList.add('atm-branch-locator__content--item__alsooffers--headingcontainer');
            servicesHeadingContainer.addEventListener('click', function (event) {
                var popup = _this.element.querySelector('.atm-branch-locator__popup--services');
                if (popup.classList.contains('atm-branch-locator__popup--services__opened')) {
                    popup.classList.remove('atm-branch-locator__popup--services__opened');
                }
                else {
                    popup.classList.add('atm-branch-locator__popup--services__opened');
                }
            });
            var servicesLabel = document.createElement('div');
            servicesLabel.classList.add('atm-branch-locator__content--item__alsooffers--heading');
            servicesLabel.innerHTML = 'SERVICES & FACILITIES PROVIDED';
            servicesHeadingContainer.appendChild(servicesLabel);
            var servicesIcon = document.createElement('a');
            servicesIcon.classList.add('atm-branch-locator__content--item__alsooffers--icon');
            servicesIcon.setAttribute('data-intent', 'search');
            servicesIcon.setAttribute('data-scope', 'AtmBranchLocator');
            servicesIcon.setAttribute('data-id', 'link_content');
            servicesIcon.setAttribute('data-text', 'Services and facilities link click');
            servicesIcon.innerHTML = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm1 3H7v2h2V3zm0 4.004H7V13h2V7.004z\"/>\n\t\t\t</svg>";
            servicesHeadingContainer.appendChild(servicesIcon);
            servicesInformation.appendChild(servicesHeadingContainer);
            var servicesItems = document.createElement('div');
            servicesItems.classList.add('atm-branch-locator__content--item__alsooffers--items');
            servicesItems.innerHTML = servicesString;
            servicesInformation.appendChild(servicesItems);
            if (servicesString) {
                servicesContainer.appendChild(servicesInformation);
            }
            container.appendChild(servicesContainer);
        }
        /////////////////////////////////////////////////////////
        /////////////////// END ALSO OFFERS ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN BUTTON ///////////////////
        /////////////////////////////////////////////////////////
        var button = document.createElement('div');
        button.classList.add('atm-branch-locator__content--item__button');
        var buttonLink = document.createElement('a');
        buttonLink.classList.add('js-get-directions');
        buttonLink.classList.add('button');
        buttonLink.classList.add('button-main');
        // buttonLink.setAttribute('href', 'https://www.google.com/maps/dir/?api=1&origin=&destination='+item.location.latitude+','+item.location.longitude);
        if (this.isIOSDevice()) {
            buttonLink.setAttribute('target', '_blank');
            // buttonLink.setAttribute('target', '_self');
            buttonLink.setAttribute('href', 'http://maps.apple.com/?daddr=' + item.location.latitude + ',' + item.location.longitude + '&=ll=' + item.location.latitude + ',' + item.location.longitude + '&q=' + item.displayName);
        }
        else if (this.isANDROIDDevice()) {
            buttonLink.setAttribute('target', '_self');
            buttonLink.setAttribute('href', 'google.navigation:q=' + item.location.latitude + ',' + item.location.longitude);
        }
        else {
            buttonLink.setAttribute('target', '_blank');
            buttonLink.setAttribute('href', 'https://www.google.com/maps/dir/?api=1&origin=&destination=' + item.location.latitude + ',' + item.location.longitude);
        }
        // analytics
        buttonLink.setAttribute('data-id', 'link_content');
        buttonLink.setAttribute('data-text', 'Location Detail | ' + item.displayName + ' | Get Directions');
        buttonLink.setAttribute('data-intent', 'Informational');
        buttonLink.setAttribute('data-scope', 'button');
        buttonLink.innerHTML = 'Get Directions';
        if (this.isIOSDevice() || this.isANDROIDDevice()) {
            button.appendChild(buttonLink);
            container.appendChild(button);
        }
        /////////////////////////////////////////////////////////
        /////////////////// END BUTTON ///////////////////
        /////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////
        /////////////////// BEGIN NOTE ///////////////////
        /////////////////////////////////////////////////////////
        var note = document.createElement('div');
        note.classList.add('atm-branch-locator__content--item__note');
        // note.innerHTML = 'NOTE: Your abiltiy to access this location may be limited by the operating hours of the shopping centre';
        note.innerHTML = 'NOTE: Keep in mind that the ATM or branch may be in a building with its own access hours. Check before you go.';
        container.appendChild(note);
        /////////////////////////////////////////////////////////
        /////////////////// END NOTE ///////////////////
        /////////////////////////////////////////////////////////
        this.containerDetail.appendChild(container);
    };
    // CLEARING EXTRAS
    AtmBranchLocator.prototype.clearMarkers = function () {
        this.containerBlocks.innerHTML = "";
        if (this.markers.length > 0) {
            for (var index = 0; index < this.markers.length; index++) {
                this.markers[index].setMap(null);
            }
        }
        this.markers = [];
    };
    AtmBranchLocator.prototype.clearEntries = function () {
        this.containerBlocks.innerHTML = '';
    };
    AtmBranchLocator.prototype.clearContent = function () {
        this.containerDetail.innerHTML = '';
    };
    AtmBranchLocator.prototype.closeDetail = function () {
        this.containerCheckboxes.classList.remove('d-none');
        this.containerBlocks.classList.remove('d-none');
        this.containerBackToResults.classList.add('d-none');
        this.containerDetail.classList.add('d-none');
    };
    AtmBranchLocator.prototype.closeNoResults = function () {
        this.containerNoResults.classList.add('d-none');
    };
    AtmBranchLocator.prototype.createArray = function (array, atms) {
        if (array === void 0) { array = []; }
        if (atms === void 0) { atms = true; }
        var newArray = [];
        for (var index = 0; index < array.length; index++) {
            var entry = array[index];
            if (this.valuesCheckboxSelected.length > 0) {
                if (this.valuesCheckboxSelected.includes('All')) {
                    if (entry.locationType === 'ATM') {
                        var atm = this.createArrayObjectNormal(entry);
                        newArray.push(atm);
                    }
                    else if (entry.locationType === 'Branch') {
                        var branch = this.createArrayObjectNormal(entry);
                        newArray.push(branch);
                        if (atms) {
                            if (entry.atms) {
                                if (entry.atms.length > 0) {
                                    var atms_1 = this.createArrayObjectAtms(entry);
                                    newArray.push(atms_1);
                                }
                            }
                        }
                    }
                }
                else {
                    if (this.valuesCheckboxSelected.includes('ATM')) {
                        if (atms) {
                            if (entry.atms) {
                                if (entry.atms.length > 0) {
                                    var atms_2 = this.createArrayObjectAtms(entry);
                                    newArray.push(atms_2);
                                }
                                else {
                                    if (entry.locationType === 'ATM') {
                                        var atm = this.createArrayObjectNormal(entry);
                                        newArray.push(atm);
                                    }
                                }
                            }
                            else {
                                if (entry.locationType === 'ATM') {
                                    var atm = this.createArrayObjectNormal(entry);
                                    newArray.push(atm);
                                }
                            }
                        }
                        else {
                            if (entry.locationType === 'ATM') {
                                var atm = this.createArrayObjectNormal(entry);
                                newArray.push(atm);
                            }
                        }
                    }
                    else {
                        if (entry.locationType === 'Branch') {
                            var branch = this.createArrayObjectNormal(entry);
                            newArray.push(branch);
                        }
                    }
                }
            }
            else {
                var branch = this.createArrayObjectNormal(entry);
                if (atms) {
                    if (entry.atms) {
                        if (entry.atms.length > 0) {
                            var atms_3 = this.createArrayObjectAtms(entry);
                            newArray.push(atms_3);
                        }
                    }
                }
                else {
                    newArray.push(branch);
                }
            }
        }
        return newArray;
    };
    AtmBranchLocator.prototype.createArrayFiltered = function (array, atms) {
        if (array === void 0) { array = []; }
        if (atms === void 0) { atms = true; }
        var newArray = [];
        for (var index = 0; index < array.length; index++) {
            var entry = array[index];
            if (this.valuesCheckboxSelected.length > 0) {
                if (this.valuesCheckboxSelected.includes('All')) {
                    if (entry.locationType === 'Branch') {
                        var branch = this.createArrayObjectNormal(entry);
                        newArray.push(branch);
                    }
                }
                else {
                    if (this.valuesCheckboxSelected.includes('ATM')) {
                        if (atms) {
                            if (entry.atms) {
                                if (entry.atms.length > 0) {
                                    var atms_4 = this.createArrayObjectAtms(entry);
                                    newArray.push(atms_4);
                                }
                            }
                            else {
                                if (entry.locationType === 'ATM') {
                                    var atm = this.createArrayObjectNormal(entry);
                                    newArray.push(atm);
                                }
                            }
                        }
                        else {
                            if (entry.locationType === 'ATM') {
                                var atm = this.createArrayObjectNormal(entry);
                                newArray.push(atm);
                            }
                        }
                    }
                    else {
                        if (entry.locationType === 'Branch') {
                            var branch = this.createArrayObjectNormal(entry);
                            newArray.push(branch);
                        }
                    }
                }
            }
            else {
                if (entry.locationType === 'Branch') {
                    var branch = this.createArrayObjectNormal(entry);
                    newArray.push(branch);
                }
            }
        }
        return newArray;
    };
    AtmBranchLocator.prototype.createArrayObjectNormal = function (entry) {
        if (entry === void 0) { entry = {}; }
        var object = {};
        object.atms = entry.atms;
        object.autobankTotal = entry.autobankTotal;
        object.autocashTotal = entry.autocashTotal;
        object.autoplusTotal = entry.autoplusTotal;
        object.branchState = entry.branchState;
        object.centerName = entry.centerName;
        object.centerNo = entry.centerNo;
        object.centerType = entry.centerType;
        object.createdAt = entry.createdAt;
        object.displayName = entry.displayName;
        object.fullCenterName = entry.fullCenterName;
        object.gresId = entry.gresId;
        object.location = entry.location;
        object.locationType = entry.locationType;
        object.sapBuId = entry.sapBuId;
        object.shoppingCenterGeneratorStatus = entry.shoppingCenterGeneratorStatus;
        object.sparkTotal = entry.sparkTotal;
        object.telNr = entry.telNr;
        object.updatedAt = entry.updatedAt;
        object.wheelChairAccess = entry.wheelChairAccess;
        object.services = entry.services;
        object.operatingHours = entry.operatingHours;
        object.tellerServices = entry.tellerServices;
        object.tellerServicesWeekdayOperatingHours = entry.tellerServicesWeekdayOperatingHours;
        object.tellerServicesWeekendOperatingHours = entry.tellerServicesWeekendOperatingHours;
        return object;
    };
    AtmBranchLocator.prototype.createArrayObjectAtms = function (entry) {
        if (entry === void 0) { entry = {}; }
        var object = {};
        object.atms = entry.atms;
        object.autobankTotal = entry.autobankTotal;
        object.autocashTotal = entry.autocashTotal;
        object.autoplusTotal = entry.autoplusTotal;
        object.branchState = entry.branchState;
        object.centerName = entry.centerName;
        object.centerNo = entry.centerNo;
        object.centerType = entry.centerType;
        object.createdAt = entry.createdAt;
        object.displayName = entry.atms[0].name;
        object.fullCenterName = entry.fullCenterName;
        object.gresId = entry.gresId;
        object.location = entry.location;
        object.locationType = "ATMs";
        object.sapBuId = entry.sapBuId;
        object.shoppingCenterGeneratorStatus = entry.shoppingCenterGeneratorStatus;
        object.sparkTotal = entry.sparkTotal;
        object.telNr = entry.telNr;
        object.updatedAt = entry.updatedAt;
        object.wheelChairAccess = entry.wheelChairAccess;
        object.services = entry.services;
        object.operatingHours = entry.operatingHours;
        object.tellerServices = entry.tellerServices;
        object.tellerServicesWeekdayOperatingHours = entry.tellerServicesWeekdayOperatingHours;
        object.tellerServicesWeekendOperatingHours = entry.tellerServicesWeekendOperatingHours;
        return object;
    };
    AtmBranchLocator.prototype.filter = function () {
        var selectedCheckboxes = [];
        this.buttonCheckboxes.map(function (checkbox) {
            if (checkbox.checked) {
                var value = checkbox.getAttribute('data-value');
                if (value === 'ATMs') {
                    selectedCheckboxes.push("ATM");
                }
                else {
                    selectedCheckboxes.push(value);
                }
            }
        });
        this.valuesCheckboxSelected = selectedCheckboxes;
        if (this.hasLatitudeLongitude) {
            this.createMap(true, true);
        }
        else {
            this.createMap(false, true);
        }
    };
    AtmBranchLocator.prototype.noResultsContainer = function () {
        // this.containerCheckboxes.classList.add('d-none');
        this.containerBlocks.classList.add('d-none');
        this.containerPagination.classList.add('d-none');
        this.containerLoader.classList.add('d-none');
        this.containerBackToResults.classList.remove('d-none');
        this.containerNoResults.classList.remove('d-none');
    };
    AtmBranchLocator.prototype.updateContentLanguage = function () {
        // back to results
        // let backToResults: any = this.element.querySelector('.js-back-to-results');
        // backToResults.innerHTML = this.valuesLanguageProperties['BranchLocator.noResultsTitle'];
        //////////////////////////////////////////////////////////
        // values
        //////////////////////////////////////////////////////////
        var valueOperatingHours = '';
        var valueTellerOperatingHours = '';
        var valueNoSearchResultsTitle = '';
        var valueNoSearchResultsIntro = '';
        var valueNoSearchResultsDescription = '';
        var valueMultipleATMs = '';
        var valueSingleATM = '';
        var valueAutoCash = '';
        var valueAutoCashDescription = '';
        var valueAutoBank = '';
        var valueAutoBankDescription = '';
        var valueAutoPlus = '';
        var valueAutoPlusDescription = '';
        var valueSpark = '';
        var valueSparkDescription = '';
        var valueAvailableATMs = '';
        var valueServicesOffered = '';
        var valueDirections = '';
        var valueDisclaimer = '';
        var valueNoGps = '';
        var valueBranchState = '';
        var valueBranchStateLink = '';
        var valueGeneralInfobox = '';
        var valueAtmInfobox = '';
        var valueBusinessServices = '';
        var valueDHAServices = '';
        //////////////////////////////////////////////////////////
        // feeds
        //////////////////////////////////////////////////////////
        this.valuesLanguageProperties.forEach(function (property) {
            if (property.key === 'BranchLocator.operatinghours') {
                valueOperatingHours = property.displayText;
            }
            if (property.key === 'BranchLocator.tellerOperatingHours') {
                valueTellerOperatingHours = property.displayText;
            }
            if (property.key === 'BranchLocator.noResultsTitle') {
                valueNoSearchResultsTitle = property.displayText;
            }
            if (property.key === 'BranchLocator.noResultsIntro') {
                valueNoSearchResultsIntro = property.displayText;
            }
            if (property.key === 'BranchLocator.noResultsDescription') {
                valueNoSearchResultsDescription = property.displayText;
            }
            if (property.key === 'BranchLocator.atmmany') {
                valueMultipleATMs = property.displayText;
            }
            if (property.key === 'BranchLocator.atmremote') {
                valueSingleATM = property.displayText;
            }
            if (property.key === 'BranchLocator.autocash') {
                valueAutoCash = property.displayText;
            }
            if (property.key === 'BranchLocator.autoCashDescription') {
                valueAutoCashDescription = property.displayText;
            }
            if (property.key === 'BranchLocator.autobank') {
                valueAutoBank = property.displayText;
            }
            if (property.key === 'BranchLocator.autoBankDescription') {
                valueAutoBankDescription = property.displayText;
            }
            if (property.key === 'BranchLocator.autoplus') {
                valueAutoPlus = property.displayText;
            }
            if (property.key === 'BranchLocator.autoPlusDescription') {
                valueAutoPlusDescription = property.displayText;
            }
            if (property.key === 'BranchLocator.spark') {
                valueSpark = property.displayText;
            }
            if (property.key === 'BranchLocator.sparkDescription') {
                valueSparkDescription = property.displayText;
            }
            if (property.key === 'BranchLocator.availableatms') {
                valueAvailableATMs = property.displayText;
            }
            if (property.key === 'BranchLocator.servicesavailable') {
                valueServicesOffered = property.displayText;
            }
            if (property.key === 'BranchLocator.directions') {
                valueDirections = property.displayText;
            }
            if (property.key === 'BranchLocator.disclaimer') {
                valueDisclaimer = property.displayText;
            }
            if (property.key === 'BranchLocator.noGPS') {
                valueNoGps = property.displayText;
            }
            if (property.key === 'BranchLocator.temporaryClosureMessage') {
                valueBranchState = property.displayText;
            }
            if (property.key === 'BranchLocator.temporaryClosureMessageLinkText') {
                valueBranchStateLink = property.displayText;
            }
            if (property.key === 'BranchLocator.generalinfobox') {
                valueGeneralInfobox = property.displayText;
            }
            if (property.key === 'BranchLocator.atminfobox') {
                valueAtmInfobox = property.displayText;
            }
            if (property.key === 'BranchLocator.businessServices') {
                valueBusinessServices = property.displayText;
            }
            if (property.key === 'BranchLocator.dha_services') {
                valueDHAServices = property.displayText;
            }
        });
        //////////////////////////////////////////////////////////
        // operating hours
        //////////////////////////////////////////////////////////
        var operatingHours = Array.from(this.element.querySelectorAll('.atm-branch-locator__content--item__operating--title'));
        operatingHours.map(function (item) {
            item.innerHTML = valueOperatingHours;
        });
        //////////////////////////////////////////////////////////
        // teller operating hours
        //////////////////////////////////////////////////////////
        var tellerOperatingHours = Array.from(this.element.querySelectorAll('.atm-branch-locator__content--item__teller--title'));
        tellerOperatingHours.map(function (item) {
            item.innerHTML = valueTellerOperatingHours;
        });
        //////////////////////////////////////////////////////////
        // no search results
        //////////////////////////////////////////////////////////
        var searchTitle = this.containerNoResults.querySelector('.atm-branch-locator__noresults--title');
        searchTitle.innerHTML = valueNoSearchResultsTitle;
        var searchDescription = this.containerNoResults.querySelector('.atm-branch-locator__noresults--description');
        searchDescription.innerHTML = valueNoSearchResultsIntro;
        var searchDescriptionBolded = this.containerNoResults.querySelector('.bolded');
        searchDescriptionBolded.innerHTML = valueNoSearchResultsDescription;
        //////////////////////////////////////////////////////////
        // atm descriptors
        //////////////////////////////////////////////////////////
        var multipleAtms = Array.from(this.element.querySelectorAll('.js-descriptor-multiple-atms'));
        multipleAtms.map(function (atm) {
            atm.innerHTML = valueMultipleATMs;
        });
        var standaloneAtms = Array.from(this.element.querySelectorAll('.js-descriptor-standalone-atm'));
        standaloneAtms.map(function (atm) {
            atm.innerHTML = valueSingleATM;
        });
        //////////////////////////////////////////////////////////
        // atm popup
        //////////////////////////////////////////////////////////
        var autoCash = this.element.querySelector('.js-descriptor-popup-autocash');
        autoCash.innerHTML = '<strong>' + valueAutoCash + '</strong>';
        var autoCashDesc = this.element.querySelector('.js-descriptor-popup-autocash-desc');
        autoCashDesc.innerHTML = valueAutoPlusDescription;
        var autoBank = this.element.querySelector('.js-descriptor-popup-autobank');
        autoBank.innerHTML = '<strong>' + valueAutoBank + '</strong>';
        var autoBankDesc = this.element.querySelector('.js-descriptor-popup-autobank-desc');
        autoBankDesc.innerHTML = valueAutoBankDescription;
        var autoPlus = this.element.querySelector('.js-descriptor-popup-autoplus');
        autoPlus.innerHTML = '<strong>' + valueAutoPlus + '</strong>';
        var autoPlusDesc = this.element.querySelector('.js-descriptor-popup-autoplus-desc');
        autoPlusDesc.innerHTML = valueAutoPlusDescription;
        var spark = this.element.querySelector('.js-descriptor-popup-spark');
        spark.innerHTML = '<strong>' + valueSpark + '</strong>';
        var sparkDesc = this.element.querySelector('.js-descriptor-popup-spark-desc');
        sparkDesc.innerHTML = valueSparkDescription;
        //////////////////////////////////////////////////////////
        // available atms
        //////////////////////////////////////////////////////////
        var availableAtms = Array.from(this.element.querySelectorAll('.atm-branch-locator__content--item__availableatms--title'));
        availableAtms.map(function (item) {
            item.innerHTML = valueAvailableATMs;
        });
        //////////////////////////////////////////////////////////
        // services offered
        //////////////////////////////////////////////////////////
        var servicesOffered = Array.from(this.element.querySelectorAll('.atm-branch-locator__content--item__alsooffers--heading'));
        servicesOffered.map(function (item) {
            item.innerHTML = valueServicesOffered;
        });
        //////////////////////////////////////////////////////////
        // atms
        //////////////////////////////////////////////////////////
        var autoCashAtms = Array.from(this.element.querySelectorAll('.js-descriptor-atm-autocash'));
        autoCashAtms.map(function (atmCash) {
            atmCash.innerHTML = atmCash.innerHTML.replace('Autocash', valueAutoCash);
        });
        var autoBankAtms = Array.from(this.element.querySelectorAll('.js-descriptor-atm-autobank'));
        autoBankAtms.map(function (atmBank) {
            atmBank.innerHTML = atmBank.innerHTML.replace('Autobank', valueAutoBank);
        });
        var autoPlusAtms = Array.from(this.element.querySelectorAll('.js-descriptor-atm-autoplus'));
        autoPlusAtms.map(function (atmPlus) {
            atmPlus.innerHTML = atmPlus.innerHTML.replace('Autoplus', valueAutoPlus);
        });
        //////////////////////////////////////////////////////////
        // get directions button
        //////////////////////////////////////////////////////////
        var getDirectionsButton = Array.from(this.element.querySelectorAll('.js-get-directions'));
        getDirectionsButton.map(function (item) {
            item.innerHTML = valueDirections;
        });
        //////////////////////////////////////////////////////////
        // disclaimer
        //////////////////////////////////////////////////////////
        var disclaimer = Array.from(this.element.querySelectorAll('.atm-branch-locator__content--item__note'));
        disclaimer.map(function (item) {
            item.innerHTML = 'NOTE: ' + valueDisclaimer;
        });
        //////////////////////////////////////////////////////////
        // no gps
        //////////////////////////////////////////////////////////
        var nogpsTitle = this.element.querySelector('.js-descriptor-popup-spark');
        var nogpsDescriptin = this.element.querySelector('.atm-branch-locator__nogps--description');
        nogpsDescriptin.innerHTML = valueNoGps;
        //////////////////////////////////////////////////////////
        // branch state
        //////////////////////////////////////////////////////////
        if (valueBranchState) {
            var stateString_1 = '';
            var branchStateTitle = Array.from(document.querySelectorAll('.atm-branch-locator__item--content__state--text'));
            stateString_1 += valueBranchState + '.';
            stateString_1 += '<a href="' + this.attributeClosureLink + '" target="_blank">' + valueBranchStateLink + '</a>.';
            branchStateTitle.map(function (item) {
                item.innerHTML = stateString_1;
            });
        }
        //////////////////////////////////////////////////////////
        // general info box
        //////////////////////////////////////////////////////////
        if (valueGeneralInfobox) {
            var generalInfoBox = this.element.querySelector('.atm-branch-locator__popup--generalinfo__inner--content');
            generalInfoBox.innerHTML = valueGeneralInfobox;
        }
        //////////////////////////////////////////////////////////
        // atm info box
        //////////////////////////////////////////////////////////
        if (valueAtmInfobox) {
            var atminfoBox = this.element.querySelector('.atm-branch-locator__popup--inner--content');
            atminfoBox.innerHTML = valueAtmInfobox;
        }
        //////////////////////////////////////////////////////////
        // business services
        //////////////////////////////////////////////////////////
        if (valueBusinessServices) {
            var businessServicesContainer = Array.from(this.element.querySelectorAll('.atm-branch-locator__content--item__alsooffers--items'));
            businessServicesContainer.forEach(function (businessServicesContainerItem) {
                var businessServicesContainerItemContent = businessServicesContainerItem.innerHTML;
                businessServicesContainerItemContent = businessServicesContainerItemContent.replace(/Business Services/g, valueBusinessServices);
                businessServicesContainerItem.innerHTML = businessServicesContainerItemContent;
            });
        }
    };
    AtmBranchLocator.prototype.getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    AtmBranchLocator.prototype.isIOSDevice = function () {
        return !!navigator.platform && /iPad|iPhone|iPod|AppleWebKit/.test(navigator.platform);
    };
    AtmBranchLocator.prototype.isANDROIDDevice = function () {
        return !!navigator.platform && /Android/.test(navigator.platform);
    };
    AtmBranchLocator.prototype.detectHeader = function () {
        if (document.querySelector('.header')) {
            this.containerSearchBar.classList.add('web');
            this.containerFiltering.classList.add('web');
            this.containerPopup.classList.add('web');
            this.containerPopupServices.classList.add('web');
            this.containerPopupGeneralInfo.classList.add('web');
        }
    };
    // filteringOptions
    AtmBranchLocator.prototype.initFilteringOptions = function (element) {
        var _this = this;
        if (element === void 0) { element = undefined; }
        if (element) {
            if (this.element.querySelector('.atm-branch-locator__filtering')) {
                this.filteringOptionsContainer = Array.from(this.element.querySelectorAll('.atm-branch-locator__filtering'));
            }
            if (this.element.querySelector('.atm-branch-locator__filtering--desktop')) {
                this.filteringOptionsDesktopAccordion = Array.from(this.element.querySelectorAll('.atm-branch-locator__filtering--desktop'));
            }
            if (this.element.querySelector('div.filter-modal-mobile')) {
                this.filteringOptionsMobileModal = Array.from(this.element.querySelectorAll('div.filter-modal-mobile'));
            }
            if (this.element.querySelector('.atm-branch-locator__filtering--display__checkboxes')) {
                this.filteringOptionsCheckboxes = Array.from(this.element.querySelectorAll('input.js-filtering-options-checkbox'));
            }
            if (this.element.querySelector('.atm-branch-locator__filtering--display__buttons--apply')) {
                this.filteringOptionsButtonApply = Array.from(this.element.querySelectorAll('.atm-branch-locator__filtering--display__buttons--apply'));
                this.filteringOptionsButtonApply.map(function (item) { return item.addEventListener('click', function (event) {
                    _this.containerBackToResults.classList.add('d-none');
                    _this.containerDetail.classList.add('d-none');
                    _this.containerNoResults.classList.add('d-none');
                    _this.containerCheckboxes.classList.remove('d-none');
                    _this.containerBlocks.classList.remove('d-none');
                    _this.containerPagination.classList.add('d-none');
                    // close accordion
                    if (_this.filteringOptionsContainer) {
                        _this.filteringOptionsContainer.map(function (container) {
                            if (container.querySelector('.accordion--collapse')) {
                                var accordionContainerMain = container.querySelector('.accordion--collapse');
                                var accordionContainerContent = container.querySelector('.accordion--collapse__container');
                                accordionContainerMain.classList.remove('accordion--collapse__opened');
                                accordionContainerContent.style.height = '0px';
                            }
                        });
                    }
                    // close modal
                    if (_this.filteringOptionsContainer) {
                        _this.filteringOptionsContainer.map(function (container) {
                            if (container.querySelector('.modal')) {
                                var modalContainerMain = container.querySelector('.modal');
                                modalContainerMain.classList.add('modal--close');
                                modalContainerMain.classList.add('modal--closed');
                            }
                        });
                    }
                    // create array of selected items
                    var allSelected = false;
                    var checkedCheckboxes = [];
                    _this.filteringOptionsCheckboxes.map(function (item) {
                        if (item.value !== 'all') {
                            if (item.checked) {
                                checkedCheckboxes.push(item.value);
                            }
                        }
                        else {
                            if (item.checked) {
                                allSelected = true;
                            }
                        }
                    });
                    if (allSelected) {
                        _this.filteringOptionsItemsValues = '';
                    }
                    else {
                        _this.filteringOptionsItemsValues = checkedCheckboxes.join();
                    }
                    // run function
                    _this.createMap(false, true);
                }); });
            }
            if (this.element.querySelector('.atm-branch-locator__filtering--display__buttons--clear')) {
                this.filteringOptionsButtonClear = Array.from(this.element.querySelectorAll('.atm-branch-locator__filtering--display__buttons--clear'));
                this.filteringOptionsButtonClear.map(function (item) { return item.addEventListener('click', function (event) {
                    _this.filteringOptionsClearSelectAll();
                    // // enable all filters
                    // if(this.filteringOptionsCheckboxes) {
                    // 	this.filteringOptionsCheckboxes.map((item)=>{
                    // 		item.checked = true;
                    // 		item.setAttribute('checked', 'checked');
                    // 	})
                    // }
                    // // close accordion
                    // if(this.filteringOptionsContainer){
                    // 	this.filteringOptionsContainer.map((container: any) => {
                    // 		if(container.querySelector('.accordion--collapse')) {
                    // 			let accordionContainerMain: any = container.querySelector('.accordion--collapse');
                    // 			let accordionContainerContent: any = container.querySelector('.accordion--collapse__container');
                    // 			accordionContainerMain.classList.remove('accordion--collapse__opened');
                    // 			accordionContainerContent.style.height = '0px';
                    // 		}
                    // 	})
                    // }
                    // // close modal
                    // if(this.filteringOptionsContainer){
                    // 	this.filteringOptionsContainer.map((container: any) => {
                    // 		if(container.querySelector('.modal')) {								
                    // 			let modalContainerMain: any = container.querySelector('.modal');
                    // 			modalContainerMain.classList.add('modal--close');
                    // 			modalContainerMain.classList.add('modal--closed');
                    // 		}
                    // 	})
                    // }	
                    // // empty selected values
                    // this.filteringOptionsItemsValues = '';
                    // run function
                    _this.createMap(false, true);
                }); });
            }
            if (this.filteringOptionsCheckboxes) {
                var items = [];
                this.filteringOptionsCheckboxes.map(function (item) { return item.addEventListener('change', function (evt) {
                    var element = undefined;
                    if (evt.currentTarget) {
                        element = evt.currentTarget;
                    }
                    else {
                        element = evt.target;
                    }
                    if (element.hasAttribute('checked')) {
                        if (element.value === 'all') {
                            element.checked = false;
                            element.removeAttribute('checked');
                            _this.filteringOptionsCheckboxes.map(function (itemInner) {
                                itemInner.checked = false;
                                element.removeAttribute('checked');
                            });
                        }
                        else {
                            element.checked = false;
                            element.removeAttribute('checked');
                            _this.filteringOptionsCheckboxes.map(function (itemInner) {
                                if (itemInner.value === 'all') {
                                    itemInner.checked = false;
                                    itemInner.removeAttribute('checked');
                                }
                            });
                        }
                    }
                    else {
                        if (element.value === 'all') {
                            element.checked = true;
                            element.setAttribute('checked', 'checked');
                            _this.filteringOptionsCheckboxes.map(function (itemInner) {
                                itemInner.checked = true;
                                element.setAttribute('checked', 'checked');
                            });
                        }
                        else {
                            element.checked = true;
                            element.setAttribute('checked', 'checked');
                        }
                    }
                }); });
            }
        }
    };
    AtmBranchLocator.prototype.filteringOptionsEnabled = function () {
        if (this.filteringOptionsContainer) {
            this.filteringOptionsContainer.map(function (container) {
                container.classList.remove('atm-branch-locator__filtering--disabled');
            });
        }
    };
    AtmBranchLocator.prototype.filteringOptionsDisabled = function () {
        if (this.filteringOptionsContainer) {
            this.filteringOptionsContainer.map(function (container) {
                container.classList.add('atm-branch-locator__filtering--disabled');
                if (container.querySelector('.accordion--collapse')) {
                    var accordionContainerMain = container.querySelector('.accordion--collapse');
                    var accordionContainerContent = container.querySelector('.accordion--collapse__container');
                    accordionContainerMain.classList.remove('accordion--collapse__opened');
                    accordionContainerContent.style.height = '0px';
                }
            });
        }
    };
    AtmBranchLocator.prototype.filteringOptionsShowHide = function (show) {
        if (show === void 0) { show = true; }
        if (show) {
            if (this.filteringOptionsContainer) {
                this.filteringOptionsContainer.map(function (container) {
                    container.classList.remove('atm-branch-locator__filtering--disabled');
                });
            }
        }
        else {
            if (this.filteringOptionsContainer) {
                this.filteringOptionsContainer.map(function (container) {
                    container.classList.add('atm-branch-locator__filtering--disabled');
                });
            }
        }
    };
    AtmBranchLocator.prototype.filteringOptionsClearSelectAll = function () {
        // enable all filters
        if (this.filteringOptionsCheckboxes) {
            this.filteringOptionsCheckboxes.map(function (item) {
                item.checked = true;
                item.setAttribute('checked', 'checked');
            });
        }
        // close accordion
        if (this.filteringOptionsContainer) {
            this.filteringOptionsContainer.map(function (container) {
                if (container.querySelector('.accordion--collapse')) {
                    var accordionContainerMain = container.querySelector('.accordion--collapse');
                    var accordionContainerContent = container.querySelector('.accordion--collapse__container');
                    accordionContainerMain.classList.remove('accordion--collapse__opened');
                    accordionContainerContent.style.height = '0px';
                }
            });
        }
        // close modal
        if (this.filteringOptionsContainer) {
            this.filteringOptionsContainer.map(function (container) {
                if (container.querySelector('.modal')) {
                    var modalContainerMain = container.querySelector('.modal');
                    modalContainerMain.classList.add('modal--close');
                    modalContainerMain.classList.add('modal--closed');
                }
            });
        }
        // empty selected values
        this.filteringOptionsItemsValues = '';
    };
    // querystrings
    AtmBranchLocator.prototype.queryString = function (param) {
        if (param === void 0) { param = ''; }
        if (param) {
            var searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has(param)) {
                var value = searchParams.get(param);
                return value;
            }
        }
        return false;
    };
    return AtmBranchLocator;
}(Base));
export { AtmBranchLocator };



//////////////////
// WEBPACK FOOTER
// ./components/atm-branch-locator/atm-branch-locator.component.ts
// module id = 115
// module chunks = 0